import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footerbar from '../components/layout/Footerbar';
import PageTopIntroLine from '../components/layout/PageTopIntroLine';
import '../styles/PageTopIntro.css';
import '../styles/Portfolio.css';
import ARBackground from '../components/animations/ARBackground';
import { useWindowScrollProgressRef } from '../hooks/useWindowScrollProgressRef';
import { AURA_PORTFOLIO_ITEMS } from '../data/auraPortfolioItems';

const WorkArticle = () => {
  const bgScrollRef = useWindowScrollProgressRef();
  const { workId } = useParams();
  const item = AURA_PORTFOLIO_ITEMS.find((i) => i.id === workId);

  if (!item) {
    return <Navigate to="/work" replace />;
  }

  return (
    <>
      <ARBackground scrollProgressRef={bgScrollRef} />
      <Navbar />
      <header className="page-top-intro">
        <PageTopIntroLine text="Aura 프로젝트·현장 후기" />
      </header>

      <article className="portfolio-content portfolio-content--article work-article">
        <nav className="work-article__nav" aria-label="문서 탐색">
          <Link to="/work" className="work-article__back">
            <span className="work-article__back-arrow" aria-hidden="true">←</span>
            Work 목록으로 돌아가기
          </Link>
        </nav>

        <header className="work-article__header">
          <span className="section-eyebrow">
            {item.kind === 'review' ? 'Review / Aura' : 'Case / Aura'}
          </span>
          <p className="work-article__meta">
            <span
              className={
                item.kind === 'review'
                  ? 'portfolio-article-tag portfolio-article-tag--review'
                  : 'portfolio-article-tag'
              }
            >
              {item.tag}
            </span>
            <span className="work-article__meta-sep" aria-hidden="true">·</span>
            <time className="portfolio-article-date" dateTime={item.date}>
              {item.date}
            </time>
          </p>
          <h1 className="work-article__title">{item.title}</h1>
        </header>

        <div className="work-article__hero">
          <img src={item.image} alt="" loading="lazy" />
        </div>

        <p
          className={
            item.kind === 'review'
              ? 'work-article__lead work-article__lead--quote'
              : 'work-article__lead'
          }
        >
          {item.excerpt}
        </p>

        <div className="work-article__body">
          <h2 className="work-article__section-heading">진행 및 결과</h2>
          {item.detailParagraphs.map((para, idx) => (
            <p key={idx} className="work-article__paragraph">
              {para}
            </p>
          ))}
        </div>
      </article>

      <Footerbar />
    </>
  );
};

export default WorkArticle;
